import React from "react";
import { Box, Typography, Button } from "@mui/material";

const DeviceTestPopup = ({
  videoRef,
  micLevel,
  micActive,
  onStopTest,
  stoppingTest
}) => {
  return (
    <Box
      className="modal-content"
      sx={{
        width: "100%",
        maxWidth: "640px",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        background: "#fff",
        padding: 3,
        borderRadius: 2,
      }}
    >
      {/* Header */}
      <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
        Camera & Microphone Test
      </Typography>

      {/* Camera status */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            background: "red",
            animation: "blink 1s infinite",
          }}
        />

        <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
          Camera preview active
        </Typography>
      </Box>

      {/* Video Preview */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "16 / 9",
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "#000",
        }}
      >
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      {/* Mic Level */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={{ fontSize: 14 }}>Mic level</Typography>

        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              width: "100%",
              height: 20,
              background: "#edf2f7",
              borderRadius: 1,
              border: "1px solid #ccc",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: `${micLevel}%`,
                height: "100%",
                background:
                  "linear-gradient(135deg, #2f855a, #68d391)",
                transition: "width 0.05s",
              }}
            />
          </Box>
        </Box>

        <Typography sx={{ fontSize: 14, minWidth: 30 }}>
          {micLevel}
        </Typography>
      </Box>

      {/* Mic status */}
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: micActive ? "green" : "#888",
        }}
      >
        {micActive
          ? "Microphone detected successfully"
          : "Speak to test microphone..."}
      </Typography>

      {/* Footer button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: 2,
        }}
      >
        <Button
          onClick={onStopTest}
          disabled={stoppingTest}
          sx={{
            background:
              "linear-gradient(135deg, #f79033, #f05a6e)",
            color: "#fff",
            "&:hover": { opacity: 0.95 },
          }}
        >
          {stoppingTest ? "Processing..." : "Stop Test"}
        </Button>
      </Box>
    </Box>
  );
};

export default DeviceTestPopup;
